import React from 'react'
import { UIButton, type UIButtonProps } from './ui-button'

export interface UIButtonSecondaryProps extends
  Omit<UIButtonProps, 'variant'> {
}

/**
 * Secondary Button Component
 * Based on official shadcn button block with secondary variant
 * Use for secondary actions like cancel, back, settings
 */
export const UIButtonSecondary = React.forwardRef<HTMLButtonElement, UIButtonSecondaryProps>(
  (props, ref) => {
    return (
      <UIButton
        variant="secondary"
        ref={ref}
        {...props}
      />
    )
  }
)

UIButtonSecondary.displayName = "UIButtonSecondary"